// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Контейнер всей страницы */
.FinStats-dashboard-container {
    padding: 0px;
    font-family: Arial, sans-serif;
    color: #333;
  }
  
  /* Строка выбора диапазона дат */
  .FinStats-date-range {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 20px;
  }
  
  .FinStats-date-range label {
    display: flex;
    flex-direction: column;
    font-size: 14px;
  }
  
  .FinStats-date-range input[type="date"] {
    padding: 5px;
    font-size: 14px;
  }
  
  /* Фильтр по водителю */
  .FinStats-filters {
    margin-bottom: 20px;
  }
  
  .FinStats-filters label {
    font-size: 14px;
  }
  
  /* Окно выбора маршрутов */
  .FinStats-routes-selection {
    border: 1px solid #ddd;
    padding: 0px;
    margin-bottom: 20px;
    border-radius: 4px;
    background-color: #f9f9f9;
  }
  
  .FinStats-routes-selection h2 {
    margin-top: 0;
    font-size: 18px;
  }
  
  .FinStats-routes-list {
    max-height: 200px;
    overflow-y: auto;
    margin-bottom: 10px;
  }
  
  .FinStats-route-item {
    display: flex;
    align-items: center;
    padding: 5px 0;
    font-size: 14px;
    min-height: 35px;
  }
  
  .FinStats-route-item input[type="checkbox"] {
    margin-right: 10px;
    
  }
  
  .FinStats-routes-buttons {
    display: flex;
    gap: 10px;
  }
  
  .FinStats-routes-buttons button {
    padding: 5px 10px;
    border: none;
    border-radius: 3px;
    background-color: #007bff;
    color: #fff;
    cursor: pointer;
    font-size: 14px;
  }
  
  .FinStats-routes-buttons button:hover {
    background-color: #0056b3;
  }
  
  /* Виджеты */
  .FinStats-widgets-container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 20px;
  }
  
  .FinStats-widget-card {
    flex: 1 1 300px;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #fff;
  }
  
  .FinStats-widget-card h2 {
    margin-top: 0;
    font-size: 18px;
  }
  
  /* Статистика по оплате маршрутов */
  .FinStats-route-payment-stats {
    margin-bottom: 15px;
    border-top: 1px solid #eee;
    padding-top: 10px;
  }
  
  .FinStats-route-payment-stats h3 {
    font-size: 16px;
    margin-bottom: 5px;
  }
  
  /* Список маршрутов */
  .FinStats-routes-list-detail {
    margin-top: 20px;
  }
  
  .FinStats-route-card {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 10px;
    margin-bottom: 10px;
    background-color: #fafafa;
  }
  
  .FinStats-route-header {
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  .FinStats-route-stats p {
    margin: 3px 0;
    font-size: 14px;
  }
  

  /* Контейнер окна выбора маршрутов */
.FinStats-routes-selection {
    padding: 20px;
    font-family: Arial, sans-serif;
  }
  
  /* Заголовок окна */
  .FinStats-routes-selection h2 {
    margin-bottom: 15px;
    font-size: 20px;
  }
  
  /* Список маршрутов в виде вертикального списка */
  .FinStats-routes-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  /* Каждый элемент маршрута оформляется как полоска прогресса */
  .FinStats-route-item {
    position: relative;
    padding: 10px 15px;
    border: 1px solid #ccc;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    background-color: #f2f2f2;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  /* При наведении элемент слегка поднимается */
  .FinStats-route-item:hover {
    transform: translateY(-3px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }
  
  /* Оформление выбранного маршрута */
  .FinStats-route-item.selected {
    border: 2px solid #007bff;
    box-shadow: 0 0 8px rgba(0, 123, 255, 0.5);
  }
  
  /* Внутренний блок с информацией о маршруте */
  .FinStats-route-item .route-info {
    position: relative;
    z-index: 2;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    font-size: 14px;
    font-weight: bold;
  }
  
  /* Контейнер для полосы прогресса, занимающий всю площадь элемента */
  .FinStats-route-item .progress-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.05);
    z-index: 1;
  }
  
  /* Полоса прогресса (зеленая) — её ширина задается динамически inline-стилем */
  .FinStats-route-item .progress-bar {
    height: 200%;
    background-color: rgba(40, 167, 69, 0.7);
    transition: width 0.3s ease;
  }
  
  /* Текст с информацией о прогрессе поверх полосы */
  .FinStats-route-item .progress-text {
    position: relative;
    z-index: 2;
    font-size: 12px;
    text-align: right;
    padding: 2px 5px;
    color: #333;
  }
  
  .FinStats-pie-charts-container {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .FinStats-pie-chart {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  /* Виджет для финансовой статистики */
.widget-card.FinStats-widget-card {
  background-color: #fff;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

/* Контейнер для каждого маршрута */
.FinStats-route-payment-stats {
  border-top: 1px solid #eee;
  padding-top: 10px;
  margin-top: 10px;
}

/* Заголовок маршрута */
.FinStats-route-payment-stats h3 {
  font-size: 16px;
  margin-bottom: 8px;
  color: #333;
}

/* Параграфы с информацией по оплатам */
.FinStats-route-payment-stats p {
  margin: 4px 0;
  font-size: 14px;
  color: #555;
}

/* Для улучшения читаемости можно добавить немного отступов между группами информации */
.FinStats-route-payment-stats p:not(:last-child) {
  border-bottom: 1px dashed #ddd;
  padding-bottom: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Manager/FinStatistics/FinStatistics.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;IACI,YAAY;IACZ,8BAA8B;IAC9B,WAAW;EACb;;EAEA,gCAAgC;EAChC;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA,uBAAuB;EACvB;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA,0BAA0B;EAC1B;IACE,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;;EAEpB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,YAAY;EACZ;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA,mCAAmC;EACnC;IACE,mBAAmB;IACnB,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA,qBAAqB;EACrB;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;;EAGA,oCAAoC;AACtC;IACI,aAAa;IACb,8BAA8B;EAChC;;EAEA,mBAAmB;EACnB;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA,iDAAiD;EACjD;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,8DAA8D;EAC9D;IACE,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,qDAAqD;EACvD;;EAEA,6CAA6C;EAC7C;IACE,2BAA2B;IAC3B,wCAAwC;EAC1C;;EAEA,mCAAmC;EACnC;IACE,yBAAyB;IACzB,0CAA0C;EAC5C;;EAEA,6CAA6C;EAC7C;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,eAAe;IACf,SAAS;IACT,eAAe;IACf,iBAAiB;EACnB;;EAEA,oEAAoE;EACpE;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,UAAU;EACZ;;EAEA,8EAA8E;EAC9E;IACE,YAAY;IACZ,wCAAwC;IACxC,2BAA2B;EAC7B;;EAEA,kDAAkD;EAClD;IACE,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA,qCAAqC;AACvC;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,uFAAuF;AACvF;EACE,8BAA8B;EAC9B,mBAAmB;AACrB","sourcesContent":["/* Контейнер всей страницы */\r\n.FinStats-dashboard-container {\r\n    padding: 0px;\r\n    font-family: Arial, sans-serif;\r\n    color: #333;\r\n  }\r\n  \r\n  /* Строка выбора диапазона дат */\r\n  .FinStats-date-range {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 15px;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .FinStats-date-range label {\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .FinStats-date-range input[type=\"date\"] {\r\n    padding: 5px;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  /* Фильтр по водителю */\r\n  .FinStats-filters {\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .FinStats-filters label {\r\n    font-size: 14px;\r\n  }\r\n  \r\n  /* Окно выбора маршрутов */\r\n  .FinStats-routes-selection {\r\n    border: 1px solid #ddd;\r\n    padding: 0px;\r\n    margin-bottom: 20px;\r\n    border-radius: 4px;\r\n    background-color: #f9f9f9;\r\n  }\r\n  \r\n  .FinStats-routes-selection h2 {\r\n    margin-top: 0;\r\n    font-size: 18px;\r\n  }\r\n  \r\n  .FinStats-routes-list {\r\n    max-height: 200px;\r\n    overflow-y: auto;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .FinStats-route-item {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 5px 0;\r\n    font-size: 14px;\r\n    min-height: 35px;\r\n  }\r\n  \r\n  .FinStats-route-item input[type=\"checkbox\"] {\r\n    margin-right: 10px;\r\n    \r\n  }\r\n  \r\n  .FinStats-routes-buttons {\r\n    display: flex;\r\n    gap: 10px;\r\n  }\r\n  \r\n  .FinStats-routes-buttons button {\r\n    padding: 5px 10px;\r\n    border: none;\r\n    border-radius: 3px;\r\n    background-color: #007bff;\r\n    color: #fff;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n  }\r\n  \r\n  .FinStats-routes-buttons button:hover {\r\n    background-color: #0056b3;\r\n  }\r\n  \r\n  /* Виджеты */\r\n  .FinStats-widgets-container {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 20px;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .FinStats-widget-card {\r\n    flex: 1 1 300px;\r\n    padding: 15px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    background-color: #fff;\r\n  }\r\n  \r\n  .FinStats-widget-card h2 {\r\n    margin-top: 0;\r\n    font-size: 18px;\r\n  }\r\n  \r\n  /* Статистика по оплате маршрутов */\r\n  .FinStats-route-payment-stats {\r\n    margin-bottom: 15px;\r\n    border-top: 1px solid #eee;\r\n    padding-top: 10px;\r\n  }\r\n  \r\n  .FinStats-route-payment-stats h3 {\r\n    font-size: 16px;\r\n    margin-bottom: 5px;\r\n  }\r\n  \r\n  /* Список маршрутов */\r\n  .FinStats-routes-list-detail {\r\n    margin-top: 20px;\r\n  }\r\n  \r\n  .FinStats-route-card {\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    padding: 10px;\r\n    margin-bottom: 10px;\r\n    background-color: #fafafa;\r\n  }\r\n  \r\n  .FinStats-route-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    font-weight: bold;\r\n    margin-bottom: 5px;\r\n  }\r\n  \r\n  .FinStats-route-stats p {\r\n    margin: 3px 0;\r\n    font-size: 14px;\r\n  }\r\n  \r\n\r\n  /* Контейнер окна выбора маршрутов */\r\n.FinStats-routes-selection {\r\n    padding: 20px;\r\n    font-family: Arial, sans-serif;\r\n  }\r\n  \r\n  /* Заголовок окна */\r\n  .FinStats-routes-selection h2 {\r\n    margin-bottom: 15px;\r\n    font-size: 20px;\r\n  }\r\n  \r\n  /* Список маршрутов в виде вертикального списка */\r\n  .FinStats-routes-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n  \r\n  /* Каждый элемент маршрута оформляется как полоска прогресса */\r\n  .FinStats-route-item {\r\n    position: relative;\r\n    padding: 10px 15px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    cursor: pointer;\r\n    background-color: #f2f2f2;\r\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n  }\r\n  \r\n  /* При наведении элемент слегка поднимается */\r\n  .FinStats-route-item:hover {\r\n    transform: translateY(-3px);\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n  }\r\n  \r\n  /* Оформление выбранного маршрута */\r\n  .FinStats-route-item.selected {\r\n    border: 2px solid #007bff;\r\n    box-shadow: 0 0 8px rgba(0, 123, 255, 0.5);\r\n  }\r\n  \r\n  /* Внутренний блок с информацией о маршруте */\r\n  .FinStats-route-item .route-info {\r\n    position: relative;\r\n    z-index: 2;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n  }\r\n  \r\n  /* Контейнер для полосы прогресса, занимающий всю площадь элемента */\r\n  .FinStats-route-item .progress-container {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.05);\r\n    z-index: 1;\r\n  }\r\n  \r\n  /* Полоса прогресса (зеленая) — её ширина задается динамически inline-стилем */\r\n  .FinStats-route-item .progress-bar {\r\n    height: 200%;\r\n    background-color: rgba(40, 167, 69, 0.7);\r\n    transition: width 0.3s ease;\r\n  }\r\n  \r\n  /* Текст с информацией о прогрессе поверх полосы */\r\n  .FinStats-route-item .progress-text {\r\n    position: relative;\r\n    z-index: 2;\r\n    font-size: 12px;\r\n    text-align: right;\r\n    padding: 2px 5px;\r\n    color: #333;\r\n  }\r\n  \r\n  .FinStats-pie-charts-container {\r\n    display: flex;\r\n    gap: 20px;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .FinStats-pie-chart {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n\r\n  /* Виджет для финансовой статистики */\r\n.widget-card.FinStats-widget-card {\r\n  background-color: #fff;\r\n  padding: 20px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n  box-shadow: 0 2px 5px rgba(0,0,0,0.1);\r\n}\r\n\r\n/* Контейнер для каждого маршрута */\r\n.FinStats-route-payment-stats {\r\n  border-top: 1px solid #eee;\r\n  padding-top: 10px;\r\n  margin-top: 10px;\r\n}\r\n\r\n/* Заголовок маршрута */\r\n.FinStats-route-payment-stats h3 {\r\n  font-size: 16px;\r\n  margin-bottom: 8px;\r\n  color: #333;\r\n}\r\n\r\n/* Параграфы с информацией по оплатам */\r\n.FinStats-route-payment-stats p {\r\n  margin: 4px 0;\r\n  font-size: 14px;\r\n  color: #555;\r\n}\r\n\r\n/* Для улучшения читаемости можно добавить немного отступов между группами информации */\r\n.FinStats-route-payment-stats p:not(:last-child) {\r\n  border-bottom: 1px dashed #ddd;\r\n  padding-bottom: 4px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
